var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$store.state.is_admin)?_c('Auth'):_c('div',[_c('Apartments')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }